jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
      
    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible → hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible → show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product__info-container').forEach(function(info) {
      var payment = info.querySelector('.shop__payment, .methods_of_payment');
          var pickup = info.querySelector('.product__pickup-availabilities');
              if (payment && pickup && pickup.parentNode) {
                    pickup.parentNode.insertBefore(payment, pickup);
                        }
                          });
                                                });

                                                document.addEventListener("DOMContentLoaded", function () {
                                                  var paymentSource = document.querySelector(".shop__payment, .methods_of_payment");
                                                    var stickyWrap = document.querySelector(".product-sticky-form-wrap");
                                                      if (paymentSource && stickyWrap) {
                                                          var paymentClone = paymentSource.cloneNode(true);
                                                              paymentClone.classList.add("product-sticky-payment");
                                                                  stickyWrap.insertBefore(paymentClone, stickyWrap.firstChild);
                                                                    }
                                                                    
                                                                  

                                                                    var DISCOUNT_CODE = "WILLKOMMEN10";
                                                                  
                                                                  function copyCode(code, el) {
                                                                  var original = el.textContent;
                                                                  function done() {
                                                                  el.textContent = "Kopiert! ";
                                                                  setTimeout(function () {
                                                                  el.textContent = original;
                                                                  }, 1500);
                                                                  }
                                                                  if (navigator.clipboard && navigator.clipboard.writeText) {
                                                                  navigator.clipboard.writeText(code).then(done).catch(done);
                                                                  } else {
                                                                  done();
                                                                  }
                                                                  }
                                                                  
                                                                  function createBanner(shortText) {
                                                                  var banner = document.createElement("div");
                                                                  banner.className = "saha-discount-banner";
                                                                  banner.innerHTML =
                                                                  '<span class="saha-discount-txt">' +
                                                                  (shortText ? "10% mit Code" : "Jetzt <strong>10% sparen</strong> mit Code") +
                                                                  '</span> <span class="saha-discount-code">' + DISCOUNT_CODE + '</span>';
                                                                  
                                                                  var codeEl = banner.querySelector(".saha-discount-code");
                                                                  codeEl.addEventListener("click", function () {
                                                                  copyCode(DISCOUNT_CODE, codeEl);
                                                                  });
                                                                  
                                                                  return banner;
                                                                  }
                                                                  
                                                                  document.querySelectorAll(".product__info-container .product-form__buttons").forEach(function (buttons) {
                                                                  buttons.insertAdjacentElement("beforebegin", createBanner(false));
                                                                  });
                                                                  
                                                                  document.querySelectorAll(".product-sticky-form-wrap").forEach(function (wrap) {
                                                                  wrap.insertAdjacentElement("beforebegin", createBanner(true));
                                                                  });

                                                                });